import { AbstractGameController } from "@lib/titan2/dist/game/controller/AbstractGameController";
import { FeatureType } from "../model/GameModel";
import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
import { gsap } from "gsap";
import { FeatureTransitionEvents } from "./FeatureTransitionController";
import { FeatureSelectorEvents } from "../view/abstract/display/features/FeatureSelector";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { Service } from "@lib/titan2-slingo/dist/api/Service";
export class FeatureSelectorController extends AbstractGameController {
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(FeatureSelectorControllerEvents.PRESENT_FEATURE_SELECTION, this.handlePresentFeatureSelection);
        this.registerGame(CommonGameEvent.RECOVERY, this.handleRecovery);
    }
    async handlePresentFeatureSelection() {
        this.dispatchGame(FeatureTransitionEvents.TRANSITION_FEATURE_SELECTOR);
        this.dispatchGame(FeatureSelectorEvents.REVEAL_CHOICES);
        await this.blockUntil(FeatureSelectorEvents.CHOICES_REVEALED);
        if (Service.isReplay()) {
            await this.delayFor(1);
            this.dispatchGame(new EventObject(FeatureSelectorEvents.REPLAY_EMULATE_CHOICE_CLICK.getType(), { choice: this.model.getFeatureType() === FeatureType.GOLD_FISH ? 0 : 1 }));
            await this.delayFor(0.5);
        }
        const pickEvent = Service.isReplay()
            ? new EventObject(FeatureSelectorEvents.FEATURE_PICKED.getType(), { pick: this.model.getFeatureType() === FeatureType.GOLD_FISH ? 0 : 1 })
            : await this.blockUntil(FeatureSelectorEvents.FEATURE_PICKED);
        const pick = pickEvent.getPayload().pick;
        this.dispatchGame(FeatureSelectorEvents.HIDE_CHOICES);
        await this.blockUntil(FeatureSelectorEvents.HIDE_CHOICES_COMPLETE);
        this.dispatchGame(new EventObject(FeatureSelectorControllerEvents.SEND_COLLECT_CHOICE.getType(), { pick }));
    }
    createModel() {
        super.createModel();
        this.model = this.baseModel;
    }
    async blockUntil(event) {
        return new Promise(resolve => {
            this.registerGame(event, (recievedEvent) => {
                this.unregisterGame(event);
                resolve(recievedEvent);
            });
        });
    }
    async delayFor(timeInSeconds) {
        return new Promise(resolve => {
            gsap.delayedCall(timeInSeconds, resolve);
        });
    }
    handleRecovery() {
        const matchedPatterns = this.model.getGameProgress().getMatchedPatterns();
        if (matchedPatterns === 12) {
            this.dispatchGame(FeatureSelectorControllerEvents.PRESENT_FEATURE_SELECTION);
        }
    }
}
export class FeatureSelectorControllerEvents {
}
FeatureSelectorControllerEvents.PRESENT_FEATURE_SELECTION = new EventObject("FeatureSelectorEvents.PRESENT_FEATURE_SELECTION");
FeatureSelectorControllerEvents.SEND_COLLECT_CHOICE = new EventObject("FeatureSelectorEvents.SEND_COLLECT_CHOICE");
//# sourceMappingURL=FeatureSelectorController.js.map